import {status} from '@/constants'

const actions = {
    confirm: {
        icon: 'mdi-check',
        title: 'Сообщить об оплате'
    },
    confirmFullPayment: {
        icon: 'mdi-check',
        title: 'Сообщить о доплате'
    },
    confirmPrepayment: {
        icon: 'mdi-piggy-bank-outline',
        title: 'Сообщить о предоплате'
    },
    editConfirmation: {
        icon: 'mdi-pencil',
        title: 'Изменить подтверждение'
    },
    pay: {
        icon: 'mdi-credit-card-outline',
        title: 'Оплатить'
    }
}

const overstatuses = {
    needConfirmFullPayment: {
      id: 'needConfirmFullPayment',
      title: 'Доплачен, ожидает подтверждения',
      color: 'teal',
      icon: 'mdi-account-clock'
    },
    needConfirmPrepayment: {
        id: 'needConfirmPrepayment',
        title: 'Предоплачен, ожидает подтверждения',
        color: 'blue-grey',
        icon: 'mdi-account-clock'
    },
    needCreate: {
        id: 'needCreate',
        title: 'Ожидает выставления счета',
        color: 'orange',
        icon: 'mdi-currency-usd-off'
    },
    needVerify: {
        id: 'needVerify',
        title: 'Ожидает проверки',
        color: 'pink',
        icon: 'mdi-shopping-cart'
    },
    unpayedPrepayment: {
        id: 'unpayedPrepayment',
        title: 'Ожидает предоплаты',
        color: 'red',
        icon: 'mdi-currency-usd-off'
    }
}

export class InvoiceContext {
    constructor (buyout, buyoutItem, invoice) {
        function check (field) {
            return !!field
        }

        this.buyoutNeedPay = check(buyout.needPay)

        if (buyoutItem) {
            this.buyoutItemHasPaymentUrl = check(buyoutItem.paymentUrl)
            this.buyoutItemVerified = check(buyoutItem.verified)
        }

        this.statusNeedConfirm = invoice.status === status.payment.needConfirm.id
        this.statusPayed = invoice.status === status.payment.payed.id
        this.statusPrepayed = invoice.status === status.payment.prepayed.id
        this.statusUnpayed = invoice.status === status.payment.unpayed.id

        this.hasAmountDiff = check(invoice.amountDiff)
        this.hasConfirmation = check(invoice.confirmation)
        this.hasConfirmationPrepayment = check(invoice.confirmationPrepayment)
        this.hasPrepayment = check(invoice.prepayment)

        this.isPrepayed = check(invoice.isPrepayed)
        this.isUnpayed = this.statusUnpayed && !this.buyoutNeedPay && this.buyoutItemVerified

        this.allowedEditConfirm = this.hasConfirmation || (this.hasConfirmationPrepayment && !this.isPrepayed)
        this.allowedConfirm = this.buyoutNeedPay && !this.statusPayed && this.buyoutItemVerified
        this.allowedConfirmFullPayment = this.isPrepayed
        this.allowedConfirmPayment = this.hasPrepayment && !this.hasConfirmationPrepayment
        this.allowedPay = this.buyoutItemHasPaymentUrl

        this.overstatusNeedCreate = this.isUnpayed
        this.overstatusNeedConfirmFullPayment = this.statusNeedConfirm && this.isPrepayed && this.hasConfirmationPrepayment && this.hasConfirmation
        this.overstatusNeedConfirmPrepayment = this.statusNeedConfirm && this.hasConfirmationPrepayment && !this.isPrepayed
        this.overstatusNeedVerify = !this.buyoutItemVerified
        this.overstatusUnpayedPrepayment = this.hasPrepayment && !this.hasConfirmationPrepayment
    }
}

export class InvoiceModel {
    constructor (ccy, invoice, invoiceContext) {
        this.action = getAction()
        this.description = getDescription()
        this.status = getStatus()

        function getAction () {
            if (invoiceContext.allowedPay) {
                return actions.pay

            } else if (invoiceContext.allowedEditConfirm) {
                return actions.editConfirmation

            } else if (invoiceContext.allowedConfirmPayment) {
                return actions.confirmPrepayment

            } else if (invoiceContext.allowedConfirmFullPayment) {
                return actions.confirmFullPayment

            } else if (invoiceContext.allowedConfirm) {
                return actions.confirm
            }
        }
        function getDescription () {
            if (invoiceContext.statusPrepayed
                || invoiceContext.hasConfirmationPrepayment && !invoiceContext.hasConfirmation) {
                if (invoice.amountDiff) {
                    let actualAmount = invoice.amount - invoice.amountDiff
                    let forFullPayment = actualAmount - invoice.confirmationPrepayment.amount
                    return `Предоплачено ${invoice.confirmationPrepayment.amount} ${ccy}${forFullPayment > 0 ? ', осталось доплатить ' + forFullPayment + ccy : ''}`
                }
                if (!invoice.amountDiff) {
                    let forFullPayment = Math.round((invoice.amount - invoice.confirmationPrepayment.amount) * 100) / 100
                    return `Предоплачено ${invoice.confirmationPrepayment.amount} ${ccy}${forFullPayment > 0 ? ', осталось доплатить ' + forFullPayment + ccy : ''}`
                }


            } else if (invoiceContext.overstatusUnpayedPrepayment || (invoiceContext.hasConfirmationPrepayment && invoiceContext.hasPrepayment)) {
                let from = invoice.prepayment.from, to = invoice.prepayment.to
                return `Предоплата${from > 0 ? ' от ' + from + ccy : ''}${to < invoice.amount ? ' до ' + to + ccy : ''}`

            } else if (invoiceContext.isPrepayed
                && invoiceContext.hasConfirmationPrepayment
                && invoiceContext.hasConfirmation) {
                return `Счет оплачен полностью
                    ${invoice.confirmation.amount
                        ? '(с предоплатой ' + invoice.confirmationPrepayment.amount + ' ' + ccy + ' и доплатой ' + invoice.confirmation.amount + ' ' + ccy + ')'
                        : '(с предоплатой ' + invoice.confirmationPrepayment.amount + ' ' + ccy + ')'}`

            }
        }
        function getStatus () {
            if (invoiceContext.overstatusNeedVerify) {
                return overstatuses.needVerify

            } else if (invoiceContext.overstatusNeedCreate) {
                return overstatuses.needCreate

            } else if (invoiceContext.overstatusUnpayedPrepayment) {
                return overstatuses.unpayedPrepayment

            } else if (invoiceContext.overstatusNeedConfirmPrepayment) {
                return overstatuses.needConfirmPrepayment

            } else if (invoiceContext.overstatusNeedConfirmFullPayment) {
                return overstatuses.needConfirmFullPayment

            } else {
                return status.payment[invoice.status]
            }
        }
    }
}